
import { AnyAction } from 'redux';
import { IUserState, USER_STATE } from './users.model';
import { UserActionService } from './users.action';

export function userReducer(state: IUserState =  USER_STATE, action: AnyAction): IUserState {

    switch (action.type) {

        case UserActionService.USER_LIST:
            return {
              ...state,
                list: action.payload
            };

        case UserActionService.SET_USER_CURRENT:
            return {
              ...state,
                current: action.payload
            };

        case UserActionService.ADD_OR_UPDATE_USER:
          if (state.list.length !== 0) {
            const userIdx = state.list.findIndex(({id}) => id === action.payload.id);
            let updatedList = [];
            if (userIdx > -1) {
              updatedList = state.list.map((elem) => {
                if (action.payload.id === elem.id) {
                  return action.payload;
                } else {
                  return elem;
                }
              });
            } else {
              updatedList = [...state.list, action.payload];
            }
            return {
              ...state,
              list: [...updatedList]
            };
          } else {
            return {
              ...state,
              list: [action.payload]
            };
          }

        case UserActionService.DELETE_USER:
          const list = state.list.filter(user => user.id !== action.payload);
          return {
            ...state,
            list
          };

    }

    return state;
}
